<template>
  <div>
    <CSelect
      :options="selectItems"
      :value="selectedLimit"
      @input="onChangeSelect($event)"
    />
    <CPagination
      class="pagination"
      align="center"
      :active-page="activePage"
      :pages="pages"
      :double-arrows="false"
      @update:activePage="onUpdateActivePage"
    />
  </div>
</template>
<script>
import {
  createUserManagerMixin,
  userManagerStore
} from "@/mixins/userManagerMixin";

const SELECT_ITEMS_PER_PAGE = [10, 50, 100];

export default {
  name: "VUserManagerTable",

  mixins: [createUserManagerMixin()],

  props: {
    itemPerPage: {
      type: Number,
      default: 10
    },
    itemsCount: {
      type: Number,
      defalt: 120
    },
    currentPage: {
      type: Number
    }
  },

  data: () => ({
    activePage: 1,
    selectedLimit: SELECT_ITEMS_PER_PAGE[0],
    pages: 0
  }),

  computed: {
    usersCount() {
      return this[userManagerStore.getterTypes.GETTER_USERS_COUNT];
    },
    selectItems() {
      return [...SELECT_ITEMS_PER_PAGE];
    }
  },

  watch: {
    usersCount() {
      this.setInitData();
    },

    $route() {
      this.setInitData();
    }
  },

  created() {
    this.setInitData();
  },

  methods: {
    setInitData() {
      const options = this.getPrevQuery();
      this.activePage = Math.floor(options.offset / options.limit) + 1;
      this.pages = Math.ceil(
        this[userManagerStore.getterTypes.GETTER_USERS_COUNT] / options.limit
      );
      this.selectedLimit = options.limit || SELECT_ITEMS_PER_PAGE[0];
    },
    onChangeSelect(event) {
      const nextQuery = {
        ...this.getPrevQuery(),
        offset: 0,
        limit: event.target.value
      };
      this.$router.push({ query: nextQuery });
    },
    onUpdateActivePage(toPage) {
      const prevQuery = this.getPrevQuery();
      const nextQuery = {
        ...prevQuery,
        offset: prevQuery.limit * parseInt(toPage - 1)
      };
      this.$router.push({ query: nextQuery });
    },
    getPrevQuery() {
      const obj = {
        offset: parseInt(this.$route.query.offset) || 0,
        limit: parseInt(this.$route.query.limit) || this.selectItems[0]
      };

      if (this.$route.query.search) {
        obj.search = this.$route.query.search;
      }

      return obj;
    }
  }
};
</script>
